const MAP = {
  draft: "bg-zinc-100 text-zinc-700 border-zinc-300",
  submitted: "bg-blue-50 text-blue-700 border-blue-200",
  approved: "bg-green-50 text-green-700 border-green-200",
  scheduled: "bg-purple-50 text-purple-700 border-purple-200",
  published: "bg-emerald-600 text-white border-emerald-600",
  on_hold: "bg-yellow-50 text-yellow-800 border-yellow-300",
  withdrawn: "bg-red-50 text-red-700 border-red-200",
  rejected: "bg-orange-50 text-orange-700 border-orange-200",
  pending: "bg-blue-50 text-blue-700 border-blue-200",
  active: "bg-green-50 text-green-700 border-green-200",
  disabled: "bg-zinc-100 text-zinc-500 border-zinc-300",
};

export const StatusChip = ({ status, testId }) => (
  <span
    data-testid={testId || `status-chip-${status}`}
    className={`inline-flex items-center px-2 py-0.5 text-[11px] font-semibold uppercase tracking-[0.06em] border rounded-sm whitespace-nowrap ${MAP[status] || MAP.draft}`}
  >
    {String(status).replace("_", " ")}
  </span>
);

export const ROLE_LABELS = {
  super_admin: "Super admin",
  reporter_approver: "Reporter approver",
  news_approver: "News approver",
  editor: "Editor",
  reporter: "Reporter",
  reader: "Reader",
};
